import { render, staticRenderFns } from "./dimsample.vue?vue&type=template&id=1f3fe0ac"
import script from "./dimsample.vue?vue&type=script&lang=js"
export * from "./dimsample.vue?vue&type=script&lang=js"
import style0 from "./dimsample.vue?vue&type=style&index=0&id=1f3fe0ac&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports